/*
 * @Author: liuchen
 * @Deion:
 * @Date: 2022-03-30 10:40:24
 * @LastEditTime: 2023-05-25 14:40:58
 */
import Vue from 'vue'
import router from './router/index'
// import VueAxios from 'vue-axios'
import iView from 'view-design'
import 'iview/dist/styles/iview.css'
import './../public/statics/css/reset.css'
// 各API接口
import api from './api/api' // 导入api接口
// 首页模板
import App from './components/console/App.vue'
// 状态管理
import store from './vuex/store'
// 工具类
import util from "./utils/index";
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.prototype.$util = util // 将util挂载到vue的原型上

Vue.use(iView)
Vue.config.productionTip = false;
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.prototype.$util = util;// 将工具类挂载到vue的原型上

Vue.use(Viewer)
const publicData = {
  // serverUrl: "http://localhost:8096/common/ueditor_upload", // 本地
  serverUrl: "http://timemap2_laravel.shanmuzhi.com/common/ueditor_upload", // 测试服
  imageUrl: "http://timemap2_laravel.shanmuzhi.com", // 测试
  H5Url: "https://tmall-new.shanmuzhi.com", // 测试


  // imageUrl: 'http://admin.shidaijiyi.com', // 线上
  // H5Url: 'https://mall.shidaijiyi.com', // 线上
  // serverUrl: 'http://admin.shidaijiyi.com/common/ueditor_upload', // 线上
  // ossUrl: 'https://sdjyalbum.oss-cn-shanghai.aliyuncs.com/' // oss弃用
  ossUrl: 'https://sdjyalbum.obs-tj.cucloud.cn/' // oss
}
Vue.prototype.$publicData = publicData

Vue.directive('drag', //自定义指令

  {
    bind: function (el, binding) {
      let oDiv = el; //当前元素
      let self = this; //上下文
      oDiv.onmousedown = function (e) {
        //鼠标按下，计算当前元素距离可视区的距离
        let disX = e.clientX - oDiv.offsetLeft;
        let disY = e.clientY - oDiv.offsetTop;

        document.onmousemove = function (e) {
          oDiv.style.position = 'absolute';
          oDiv.style.pointerEvents = 'none';
          oDiv.style.zIndex = '100';
          //通过事件委托，计算移动的距离
          let l = e.clientX - disX;
          let t = e.clientY - disY;
          //移动当前元素
          oDiv.style.left = l + 'px';
          oDiv.style.top = t + 'px';
          //将此时的位置传出去
          // binding.value({x:e.pageX,y:e.pageY})
        };
        document.onmouseup = function (e) {
          oDiv.style.pointerEvents = 'auto';
          oDiv.style.position = 'relative';
          oDiv.style.zIndex = '10';
          oDiv.style.left = 0 + 'px';
          oDiv.style.top = 0 + 'px';
          document.onmousemove = null;
          document.onmouseup = null;
          binding.value({
            x: 1
          })
        };
      };
    }
  }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
